/**
 * ShreemTech Universal Admin Panel
 * Copyright (c) 2026 ShreemTech Ltd. All Rights Reserved.
 * PROPRIETARY AND CONFIDENTIAL — TRADE SECRET
 */

// MOCK_MODE defaults to true when NEXT_PUBLIC_MOCK_MODE is not explicitly set to "false".
// Set NEXT_PUBLIC_MOCK_MODE=false in .env.local to enable real backend connectivity.
export const MOCK_MODE = process.env.NEXT_PUBLIC_MOCK_MODE !== "false";
